var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('Table',_vm._b({},'Table',_vm.table,false)),_c('EventItem',{model:{value:(_vm.currentItem),callback:function ($$v) {_vm.currentItem=$$v},expression:"currentItem"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }